<div class="app-component app-container ver2">
  <header class="site-nav" *ngIf="isShowHeader() && !isFlyout">
    <!-- Add class of .scroll on user scroll -->
    <div class="row">
      <!-- Site logo -->
      <a href="{{configurationService.homeUrl}}">
        <img src="{{configurationService.assetsPath}}/assets/img/logos/rankipedia-logo.png" class="logo-width" alt="Logo"/>
      </a>
      <!-- Site navigation -->
      <nav [ngClass]="{'authenticated': isUserLoggedIn}">
        <a href="{{configurationService.homeUrl}}Home/Help?key=Help">Help</a>
        <a href="{{configurationService.homeUrl}}about">About</a>
        <a href="{{configurationService.homeUrl}}Home/articles">Articles/Blog</a>
        <!-- Mobile menu trigger -->
        <div class="mob-menu">
          <span></span>
          <span></span>
          <span></span>
        </div>
        <a *ngIf="!isUserLoggedIn" [routerLinkActive]="['btn', 'secondary']" [routerLink]='["/register"]'>Register</a>
        <a *ngIf="!isUserLoggedIn" (click)="signInOut()" [routerLinkActive]="['btn', 'secondary']" [routerLink]='["/login"]'>{{ !isUserLoggedIn? 'Sign In' : 'Sign Out' }}</a>
        <span class="user-menu-icon" *ngIf="isUserLoggedIn">
          <span><img src="{{configurationService.assetsPath}}/assets/img/icons/default-avatar-small.png" alt="User Avatar"></span>
          <!--<span class="msg-counter">{{this.authService.curMsgCounter}}</span>-->
        </span>
        <div class="user-menu">
          <div class="row">
            <a href="/Professional/ViewMe" class="ranki-link">
              <img src="{{configurationService.assetsPath}}/assets/img/icons/default-avatar.png" alt="User Avatar">
            </a>
            <div class="user-options">
              <h4>
                <a href="/Professional/ViewMe" class="ranki-link">{{FullName}}</a>
              </h4>
              <ul>
                <li>
                  <a href="/Professional/Edit">Edit your profile</a>
                </li>
                <li>
                  <a href="/Professional/MemberAccount">Edit your account</a>
                </li>
                <!--<li>
                  <a href="#">View your messages <span class="msg-counter">{{this.authService.curMsgCounter}}</span></a>
                </li>-->
              </ul>
            </div>
          </div>
          <div class="row actions">
            <a (click)="signInOut()" class="sign-out">Sign Out</a>
            <a href="/home/upgrade" class="btn secondary">Renew/Upgrade</a>
          </div>
        </div>
      </nav>
    </div>
  </header>
  <!-- Site content -->
  <!-- Initial wrapper for main content - class will change based on page -->
  <router-outlet></router-outlet>
  <!-- Site footer -->
  <footer class="site-footer" *ngIf="isShowFooter() && !isFlyout">
    <div class="row">
      <div class="links">
        <ul>
          <li>
            <a href="{{configurationService.homeUrl}}Home/Help?key=Help">Help</a>
          </li>
          <li>
            <a href="{{configurationService.homeUrl}}about">About</a>
          </li>
          <li>
            <a href="{{configurationService.homeUrl}}Home/articles">Articles/Blog</a>
          </li>
          <li>
            <a href="{{configurationService.homeUrl}}core-values" target="_blank">Core Values</a>
          </li>
          <li>
            <a href="{{configurationService.homeUrl}}TermsOfUse" target="_blank">Terms of Use</a>
          </li>
          <li>
            <a href="{{configurationService.homeUrl}}PrivacyPolicy" target="_blank">Privacy Policy</a>
          </li>
        </ul>
        <small>Copyright &copy; <span id="copyright-year"></span> RankLogic, Inc. All rights reserved.</small>
      </div>
      <div class="socials">
        <a href="https://www.facebook.com/Rankipedia" target="_blank"><i class="typcn typcn-social-facebook"></i></a>
        <a href="https://twitter.com/rankipedia" target="_blank"><i class="typcn typcn-social-twitter"></i></a>
        <!--<a href="https://plus.google.com/+Rankipedia" target="_blank"><i class="typcn typcn-social-google-plus"></i></a>-->
        <a href="https://www.linkedin.com/company/rankipedia" target="_blank"><i class="typcn typcn-social-linkedin"></i></a>
        <a href="https://www.youtube.com/user/rankipedia1" target="_blank"><i class="typcn typcn-social-youtube"></i></a>
      </div>
    </div>
  </footer>
</div>
<script>
  $(document).ready(function () {
    var year = new Date().getFullYear();
    $("#copyright-year")[0].innerText = year;
  });
</script>

